import TopSectionWithoutFilter from '@/TRC/components/TopSections/topSectionWithoutFilter';
import TRCHorizontalScrollComponent from '../../../components/horizontalDivComponent';
import TRC_PAGE_CATEGORIES from '../../../constants/trcCategories';

const TRCLessonsSection = ({ lessonPlans }) => {
	return (
		<section className="w-100 pt-1 pt-lg-0" style={{ background: '#27272a' }}>
			<TopSectionWithoutFilter category={TRC_PAGE_CATEGORIES.LESSON_PLANS} />
			<TRCHorizontalScrollComponent contents={lessonPlans} route="lesson-plans" className="px-lg-5" fixedWidth />
		</section>
	);
};

export default TRCLessonsSection;
